import * as I from "immutable";
import Raven from "raven-js";
import React, {Component} from "react";
import PropTypes from "prop-types";
import Select from "react-select";

import {getRouteLabel, isDesktop} from "utils";
import api from "v2/api";
import {apiError} from "v2/api/Errors";
import {apiRoute} from "v2/api/Routes";
import FieldError from "v2/components/FieldError";
import FieldGroup from "v2/components/FieldGroup";
import Loading from "v2/components/Loading";

export default class RouteSelect extends Component {
  static contextTypes = {
    params: PropTypes.shape({
      routeId: PropTypes.string.isRequired,
    }),
  }

  static propTypes = {
    error: PropTypes.string,
    fieldContainerClassName: PropTypes.string,
    focus: PropTypes.bool,
    labelClassName: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    selected: PropTypes.number,
  }

  state = {
    data: null,
  }

  componentDidMount() {
    this.loadData();
  }

  get apiUrl() {
    const {params: {routeId}} = this.context;
    return `/routes/${routeId}/similar`;
  }

  loadData() {
    api()
      .get(this.apiUrl)
      .then(({data}) => {
        this.setState({
          data: I.List(data.map(apiRoute)),
        });
      })
      .catch((err) => {
        if (err.response) {
          this.setState({
            dataError: apiError(err.response.data),
          });
        } else {
          Raven.captureException(err);
        }
      });
  }

  render() {
    const {
      error,
      fieldContainerClassName,
      focus,
      labelClassName,
      onChange,
      selected,
    } = this.props;
    const {data} = this.state;

    let content;
    if (!data) {
      content = <Loading inForm />;
    } else if (data.isEmpty()) {
      content = (
        <div className="form-control-static text-warning">
          No routes.
        </div>
      );
    } else {
      const options = data.map(route => ({
        htmlLabel: getRouteLabel(route),
        label: route.title,
        value: route.id,
      }));

      content = (
        <Select
          autoBlur
          autofocus={focus && isDesktop()}
          name="route-select"
          onChange={onChange}
          optionRenderer={item => item.htmlLabel}
          options={options.toArray()}
          placeholder="Select route"
          value={selected}
          valueRenderer={item => item.htmlLabel} />
      );
    }

    return (
      <FieldGroup error={error}>
        <label className={labelClassName}>Routes:</label>
        <div className={fieldContainerClassName}>
          {content}
          <FieldError>{error}</FieldError>
        </div>
      </FieldGroup>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/RouteSelect.js
 **/